import { DEFAULT_LANGUAGE } from "./multilang/constants";

export const getSystemLang = (fallbackLang) => {
  if (typeof window !== "undefined") {
    const windowNavigator = window.navigator;

    let lang =
      (windowNavigator.languages && windowNavigator.languages[0]) || // Firefox
      windowNavigator.language || // All browsers
      fallbackLang; // Fallback language

    if (lang.indexOf("-") !== -1) {
      return lang.split("-")[0];
    }
    return lang;
  }

  return fallbackLang;
};

export const isOnLine = () => {
  if ("window" in global && global.window.navigator) {
    return global.window.navigator.onLine;
  }
  return undefined;
};

export const getLanguageDefault = (languages = [], fallback = DEFAULT_LANGUAGE) => {
  return languages.length ? languages[0] : getSystemLang(fallback);
};

export const getCurrentLang = (i18n, language) =>
  language || (i18n.language && i18n.language.split("-")[0]) || DEFAULT_LANGUAGE;
